// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XmDt3","colBig":"styles_colBig__2PJao","colSmall":"styles_colSmall__1vbgb"};